// extracted by mini-css-extract-plugin
export var gif = "_ml-0";